<div class="container">
  <button
    class="add-filter"
    (click)="onAddFilter()"
    [ngClass]="{ invisible: !showFilterPalette }"
  >
    <mat-icon>filter_alt</mat-icon>
    <mat-icon class="add">add</mat-icon>
  </button>

  <button class="delete" mat-icon-button (click)="onClearFilters()">
    <mat-icon>filter_alt_off</mat-icon>
  </button>
</div>
